export const HomeTileTypeIds = {
  ADVANCE_ACCOUNT_CARD_SQUARE_TILE: 'ADVANCE_ACCOUNT_CARD_SQUARE_TILE',
  ACCOUNT_ACTION_TILE_ADD_MONEY_DDA: 'ACCOUNT_ACTION_TILE_ADD_MONEY_DDA',
  ACCOUNT_ACTION_TILE_TURN_ON_SAFE_PAY_CHARGE_CARD:
    'ACCOUNT_ACTION_TILE_TURN_ON_SAFE_PAY_CHARGE_CARD',
  COLUMN_TAX_PRODUCT_OFFER_SINGLE_CARD_TILE:
    'COLUMN_TAX_PRODUCT_OFFER_SINGLE_CARD_TILE',
  COLUMN_TAX_TILE: 'COLUMN_TAX_TILE',
  CREDIT_SCORE_TILE: 'CREDIT_SCORE_TILE',
  EXTERNAL_ACCOUNTS_TILE: 'EXTERNAL_ACCOUNTS_TILE',
  HOME_TILE_TOOLS_FULL_WIDTH_TEXT_COMPONENT_TILE:
    'HOME_TILE_TOOLS_FULL_WIDTH_TEXT_COMPONENT_TILE',
  INTERNAL_ACCOUNT_TILE_CHARGE_CARD: 'INTERNAL_ACCOUNT_TILE_CHARGE_CARD',
  INTERNAL_ACCOUNT_TILE_CHECKING: 'INTERNAL_ACCOUNT_TILE_CHECKING',
  INTERNAL_ACCOUNT_TILE_SAVINGS: 'INTERNAL_ACCOUNT_TILE_SAVINGS',
  LINKED_ACCOUNTS_TILE: 'LINKED_ACCOUNTS_TILE',
  LIST_ITEM_MANAGE_EXTERNAL_ACCOUNTS: 'LIST_ITEM_MANAGE_EXTERNAL_ACCOUNTS',
  NEXT_BEST_ACTION_TILE: 'NEXT_BEST_ACTION_TILE',
  PRODUCT_OFFER_TILE_SAVINGS: 'PRODUCT_OFFER_TILE_SAVINGS',
  PROMOTION_TILE_LINKED_ACCOUNTS: 'PROMOTION_TILE_LINKED_ACCOUNTS',
  PROMOTION_TILE_SETUP_DIRECT_DEPOSIT: 'PROMOTION_TILE_SETUP_DIRECT_DEPOSIT',
  QUICK_ACTION_TILES: 'QUICK_ACTION_TILES',
  SD_VERTICAL_STACK_CONTAINER_HOME_PAGE_TOOLS_SECTION_TILE:
    'SD_VERTICAL_STACK_CONTAINER_HOME_PAGE_TOOLS_SECTION_TILE',
  VLOC_ACCOUNT_CARD_SQUARE_TILE: 'VLOC_ACCOUNT_CARD_SQUARE_TILE',
  VXL_CARD_GROUP_TILE_BANKING: 'VXL_CARD_GROUP_TILE_BANKING',
  VXL_CARD_GROUP_TILE_BORROW: 'VXL_CARD_GROUP_TILE_BORROW',
  VXL_CARD_GROUP_TILE_FOR_YOU: 'VXL_CARD_GROUP_TILE_FOR_YOU',
  VXL_SIDE_BY_SIDE_TILE_ACCOUNT_CARD: 'VXL_SIDE_BY_SIDE_TILE_ACCOUNT_CARD',
  VXL_TRACKER_CARD_TILE_CREDIT_TRACKER: 'VXL_TRACKER_CARD_TILE_CREDIT_TRACKER',
  VXL_CARD_GROUP_TILE_WELCOME: 'VXL_CARD_GROUP_TILE_WELCOME',
  VXL_CARD_GROUP_TILE_DISCOVER_MORE: 'VXL_CARD_GROUP_TILE_DISCOVER_MORE',
};
